
<div *ngIf="creditBalanceIsBelowPercentage" class="alert alert-warning border-warning mx-4 mt-2 default-font-size" role="alert">
    <span class="lh-sm" innerHTML="{{ 'Settings.OrganisationCreditsSection.WarningCreditSaldo'  | translate: {url: supportUrl} }}"></span>
</div>
<div class="d-flex row-cols-12">
    <div class="col-7 mt-0">
        <h3 class="title float-start" translate="Settings.OrganisationCreditsSection.Title"></h3>
    </div>
    <div class="col-5 text-end px-4">
    </div>
</div>
<div class="px-4 mb-4 col-12">
    <div class="mb-3 mt-2 mx-0 p-1 col-12 row text-wrap border rounded lh-base">
        <div class="d-table col-10 d-flex align-items-center">
            <label class="form-check-label col-10" translate="Settings.OrganisationCreditsSection.TotalReservedCredits"
                [translateParams]="{TotalReservedCredits:totalReservedCredits}">
            </label>
        </div>
        <div class="dropdown float-end col-2">
            <button class="btn btn-sm btn-secondary mt-2 mb-2 ml-4" [disabled]="NotAllowedToAddOrDeleteCredits"
                (click)="addCredits()" translate="Button.AddCredits">
            </button>
            <app-info-button *ngIf="NotAllowedToAddOrDeleteCredits"
                labelName="Settings.OrganisationCreditsSection.CreditsTooltip">
            </app-info-button>
        </div>
    </div>
</div>
<div class="px-4">
    <app-creditList [credits]="credits" [filter]="filter" [NotAllowedToAddOrDeleteCredits]="NotAllowedToAddOrDeleteCredits" (deleteCreditBundle)="deleteCreditBundle($event)">
    </app-creditList>
</div>

<app-settings-credits-notification [OrganisationSettings]="filterSettings(notificationSettings)"
    (UpdateOrganisationSettings)="updateSettings($event)">
</app-settings-credits-notification>